function copyToClipBoard() {
  // Get the text field
  var copyText = window.location.href;

  // Select the text field
  // copyText.select();
  // copyText.setSelectionRange(0, 99999); // For mobile devices

   // Copy the text inside the text field
  navigator.clipboard.writeText(copyText);

  const shareData = {
    url: copyText,
  };
  // Alert the copied text
  
  if(document.querySelector('#shareBtnCustom')) {
    document.querySelector('#shareBtnCustom').addEventListener('click',async () => {
      console.log('sharing')
      try {
        await navigator.share(shareData);
      } catch (err) {
        // resultPara.textContent = `Error: ${err}`;
      }
    });
  }
}

// document.addEventListener('DOMContentLoaded',);

document.addEventListener("DOMContentLoaded", function(event) {
  copyToClipBoard()
  console.log("DOM loaded")

  setTimeout(() => {
    console.log(document.querySelector('.success-wrap'))
    const btn = document.querySelector('#form-iframe-17583 .success-wrap')
    const options = {
      attributes: true
    }
    
    function callback(mutationList, observer) {
      mutationList.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          console.log(mutation.target.className)
        }
      })
    }
    
    const observer = new MutationObserver(callback)
    observer.observe(btn, options)
  }, 3000);
})

setTimeout(() => {
  if(document.querySelector('shopify-buy-it-now-button')) {
    document.querySelector('shopify-buy-it-now-button').removeAttribute('disabled');
  }
    
}, 2000);


